import { TOKEN } from './apis';
import "core-js/stable/atob";
import { jwtDecode } from 'jwt-decode';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidToken = () => {
    if (!TOKEN || TOKEN === undefined || TOKEN === "undefined") {
        return false;
    }
    const decoded = jwtDecode(TOKEN);
    // milliseconds to seconds and then check if the expiration time is greater than the current time
    return decoded.exp > Date.now() / 1000;
}

export function getOrDefault(jsonObject, key, defaultValue) {
    return key in jsonObject ? jsonObject[key] : defaultValue;
}